import { render, staticRenderFns } from "./brand-manage.vue?vue&type=template&id=2775b2df&scoped=true&"
import script from "./brand-manage.vue?vue&type=script&lang=js&"
export * from "./brand-manage.vue?vue&type=script&lang=js&"
import style0 from "./brand-manage.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./brand-manage.vue?vue&type=style&index=1&id=2775b2df&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2775b2df",
  null
  
)

export default component.exports